import styled from 'styled-components';
import { Text } from '../../../../../components/ToolkitV2/Text/Text';

export const CountText = styled(Text)`
  margin-left: ${({ theme }) => theme.spacing.S4};
`;
